// extracted by mini-css-extract-plugin
export default {"statusTag":"src-pages-Order-ShoppingCartTemplate-List-StatusTag-css-module__statusTag--NM8Cw"};